import React, { useEffect, useState } from 'react';
import { Viewer } from '@react-pdf-viewer/core';
import { Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import './PDFViewer.scss';

interface PDFViewerProps {
  pdfUrl: string;
  onClose: () => void;
}

const PDFViewer: React.FC<PDFViewerProps> = ({ pdfUrl, onClose }) => {
  const [scale, setScale] = useState(2);

  // Update scale based on screen width
  useEffect(() => {
    const updateScale = () => {
      const width = window.innerWidth;
      if (width <= 768) {
        setScale(0.6);
      } else if (width <= 1024) {
        setScale(1.2);
      } else {
        setScale(2);
      }
    };

    updateScale();
    window.addEventListener('resize', updateScale);

    return () => {
      window.removeEventListener('resize', updateScale);
    };
  }, []);

  useEffect(() => {
    // Disable scrolling on mount
    document.body.style.overflow = 'hidden';
    
    // Re-enable scrolling on unmount
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <div className="pdf-viewer-overlay" onClick={onClose}>
      <div className="pdf-viewer-container" onClick={(e) => e.stopPropagation()}>
        <button className="pdf-viewer-close-button" onClick={onClose}>
          &times;
        </button>
        
        <div className="pdf-viewer-content">
          <Worker workerUrl="/pdf.worker.min.js">
            <Viewer
              fileUrl={pdfUrl}
              defaultScale={scale}
            />
          </Worker>
        </div>
      </div>
    </div>
  );
};

export default PDFViewer;
